const API = process.env.REACT_APP_BACKEND_URL;
const CHUNK_SIZE = 1024 * 1024; // 1 MB — chunked to bypass proxy body-size limits

const makeUploadId = () => {
  if (window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID().replace(/-/g, "").slice(0, 32);
  }
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 14)}`;
};

export async function uploadFileInChunks(file, onProgress) {
  const uploadId = makeUploadId();
  const totalChunks = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));

  for (let i = 0; i < totalChunks; i += 1) {
    const start = i * CHUNK_SIZE;
    const blob = file.slice(start, Math.min(start + CHUNK_SIZE, file.size));
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("chunk_index", String(i));
    fd.append("total_chunks", String(totalChunks));
    fd.append("filename", file.name);
    fd.append("chunk", blob, file.name);

    const res = await fetch(`${API}/api/uploads/chunk`, { method: "POST", body: fd });
    if (!res.ok) {
      let detail = `Upload failed (${res.status})`;
      try {
        const err = await res.json();
        if (err.detail) detail = err.detail;
      } catch (e) {
        // keep generic message
      }
      throw new Error(detail);
    }
    if (onProgress) onProgress(Math.round(((i + 1) / totalChunks) * 100));
    if (i === totalChunks - 1) {
      const data = await res.json();
      return data.file;
    }
  }
  return null;
}
